'use client';
import TierTwoHero from '@repo/ui/src/components/TierTwoHero';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import type { LinkProps } from '@repo/ui/src/types/link';
import type { MediaType } from '@repo/ui/src/types/image';
import type { HeaderVariationProps } from '@repo/ui/src/types/headerVariation';
import { HeaderVariation } from '@repo/ui/src/types/headerVariation';
import type { MetaProps } from '@repo/ui/src/types/meta';
import type { YoutubeLinkProps } from '@repo/ui/src/types/youtubeLink';
import HeaderVariety from '@primitives/HeaderVariety';
import Button from '@repo/ui/src/components/Button';
import { Anchor } from '@repo/ui/src/components/Anchor';
import { classNames } from '@repo/ui/src/utils/classNames';

interface PromoBannerProps {
  smallBanner?: boolean;
  title?: string;
  subtitle?: string;
  cta?: Array<LinkProps>;
  headerVariation?: HeaderVariationProps;
  videoOrCTA?: string;
  youtubeVideo?: YoutubeLinkProps;
  _testID?: string;
  _meta?: MetaProps;
  backgroundImage?: MediaType;
}

const PromoBanner = (props: PromoBannerProps) => {
  const { push } = useModal(ModalID.video);
  const {
    smallBanner,
    title,
    subtitle,
    cta,
    headerVariation,
    videoOrCTA,
    youtubeVideo,
    _testID,
    _meta,
    backgroundImage,
  } = props;

  const linkObj = cta?.length && cta[0];

  return (
    <div
      className={classNames(!smallBanner && 'md:h-[650px]')}
      data-test-id={`promo_banner_${_testID}`}
    >
      <TierTwoHero
        _meta={_meta!}
        backgroundImage={backgroundImage!}
        headerVariation={headerVariation!}
        opacityLayerClass="given-height"
        padding="none"
      >
        <div className="text-center">
          <HeaderVariety
            classNames="text-white"
            defaultVariation="h1"
            headerVariation={headerVariation?.headerVariation || HeaderVariation.h1}
          >
            {title && (
              <span
                className={classNames(
                  'text-white',
                  smallBanner
                    ? 'text-5xl md:text-8xl leading-[45px] md:leading-[85px]'
                    : 'text-7xl md:text-9xl leading-[55px] md:leading-[85px]',
                )}
              >
                {title}
              </span>
            )}
            <br />
            {subtitle && (
              <span
                className={classNames(
                  'text-white relative md:leading-[85px]',
                  smallBanner
                    ? 'text-4xl md:text-8xl leading-[40px] md:-top-5'
                    : 'text-6xl md:text-9xl leading-[50px] md:-top-3',
                )}
              >
                {subtitle}
              </span>
            )}
          </HeaderVariety>

          {videoOrCTA === 'Youtube Modal' && youtubeVideo ? (
            <Button onClick={() => push({ youtubeLink: youtubeVideo })}>Watch Video</Button>
          ) : (
            linkObj && (
              <div className="flex items-center justify-center align-middle">
                <Button className="max-w-[200px]" link={linkObj.link} as={Anchor}>
                  {linkObj.displayName}
                </Button>
              </div>
            )
          )}
        </div>
      </TierTwoHero>
    </div>
  );
};

export default PromoBanner;
